document.querySelectorAll('.Index_top_hero_slideshows_slider').forEach(el => {
  if (!el.classList.contains('swiper-initialized')) {
    new Swiper(el, {
        loop: true,
        grabCursor: false,
        spaceBetween: 0,
        slidesPerGroup: 1,
        slidesPerView: 1,
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        observer: true,
        observeParents: true,
        effect: "fade",
        speed: 300,
        fadeEffect: {
            crossFade: true,
        },
        autoplay: {
            delay: 10000,
            disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',

          formatFractionCurrent: function (number) {
            return number < 10 ? '0' + number : number;
          },

          formatFractionTotal: function (number) {
            return number < 10 ? '0' + number : number;
          }
        },
        scrollbar: {
          el: ".swiper-scrollbar"
        }
    })
  }
});